import mapResponseToEvent from '../mappers/mapResponseToEvent'
import transform from '../../../utils/ResponseTransformator'
import { IData } from './response'

export default async function(response: Response) {
  let text: string = await response.text()
  text = transform(text)

  const json: IData = JSON.parse(text)

  return json.items ? json.items.map(mapResponseToEvent) : []
}
